/** Loading placeholder shown while the evidence bundle is being fetched and validated. */
export function RouteSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading evidence bundle"
      className="mx-auto max-w-3xl px-6 py-16"
    >
      <div className="h-4 w-40 animate-pulse rounded bg-surface motion-reduce:animate-none" />
      <div className="mt-6 h-24 animate-pulse rounded bg-surface motion-reduce:animate-none" />
      <div className="mt-4 h-24 animate-pulse rounded bg-surface motion-reduce:animate-none" />
      <span className="sr-only">Loading evidence bundle…</span>
    </div>
  );
}
